<template>
  <button 
    :aria-label="isContentSaved ? 'Saved' : 'Add to Saved List'"
    tabindex="0"
    data-jest="save-toggle-wrapper"
    class="sj-save-toggle-wrapper"
    @click="toggleSaved"
    @keydown.space.prevent="toggleSaved"
  >
    <sjwc-icon
      :name="iconName"
      aria-hidden="true"
      class="sj-save-toggle"
    />
  </button>
</template>

<script setup>
import { ref, computed, defineProps } from 'vue';
import ApiService from '@utils/services/api-service';

const props = defineProps({
  publishedCourseId: {
    type: String,
    default: null,
  },
  publishedPathId: {
    type: String,
    default: null,
  },
  isContentSaved: {
    type: Boolean,
    default: false
  }
});

const isContentSaved = ref(props.isContentSaved);
const loading = ref(false);

const iconName = computed(() => {
  if (loading.value) {
    return 'fa fa-spinner fa-spin';
  }
  return isContentSaved.value ? 'fa fa-bookmark' : 'fa fa-bookmark-o';
});

const toggleSaved = async () => {
  if (!props.publishedCourseId && !props.publishedPathId) return;
  const contentType = props.publishedCourseId ? 'published_course' : 'published_path';

  const params = {
    content_type: contentType,
    is_active: !isContentSaved.value,
  }

  if (props.publishedCourseId) {
    params.published_course_id = props.publishedCourseId;
  } else if (props.publishedPathId) {
    params.published_path_id = props.publishedPathId;
  }

  try {
    loading.value = true;
    await ApiService.saveContentForLater(params);
    isContentSaved.value = !isContentSaved.value;
  } catch (error) {
    const errorType = !isContentSaved.value
      ? 'save-error'
      : 'remove-save-error';

    // Dispatch custom DOM event for error handling
    const errorEvent = new CustomEvent('save-content-error', {
      detail: errorType,
      bubbles: true
    });
    document.dispatchEvent(errorEvent);
  } finally {
    loading.value = false;
  }
};
</script>
